import _ from 'lodash'
import { of } from 'rxjs'
import { first, switchMap } from 'rxjs/operators'

import { Alias } from '@skinsoft/types'
import { authoritySelectors } from '@skinsoft/selectors'
import { OfflineDataFetcher } from '../offline-data-fetcher'
import { CACHE_KEYS } from '../search-type-cache-key-mapping'
import { AuthorityOfflineDataFetcher } from './authority-offline-data-fetcher'

export class AliasOfflineDataFetcher extends OfflineDataFetcher<Alias>{

    constructor(cacheKey: string) {
        super(cacheKey);
    }

    public getByUser(userId: string) {
        return new AuthorityOfflineDataFetcher(CACHE_KEYS.Authority).fetchOneFromPredicate(
            authority => authoritySelectors.linkedAccount(authority) === userId
        )
            .pipe(
                first(),
                switchMap(
                    theLinkedAuthority => of(authoritySelectors.firstAlias(theLinkedAuthority))
                ),
            )
    }

}